<template>
<div class="chapter">
<div class="inner_page">
<p class="linespace"> </p>
<p class="linespace"> </p>
<p class="center-para"><a id="page_ii"></a>Also by Homer Hickam</p>
<p class="para"> </p>
<p class="center-paraa"><em>Torpedo Junction</em><br/><em>Rocket Boys</em> (a.k.a. <em>October Sky</em>)<br/><em>Back to the Moon</em><br/><em>The Coalwood Way</em><br/><em>Sky of Stone</em><br/><em>We Are Not Afraid</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abouttheauthor.vue?4a8c0944